import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import {  Row, Col, Button, Card } from 'antd';

class DoseTimeDirectionPool extends Component {

    state = {
        times: [
            ["06:00 AM", "Empty Stomach"], 
            ["07:00 AM", "Before Food"], 
            ["09:00 AM", "After Food"], 
            ["02:00 PM", "After Food"], 
            ["06:00 PM", "No Food Direction"], 
            ["08:00 PM", "Before Food"], 
            ["09:00 PM", "After Food"], 
            ["10:00 PM", "Bed Time"],
        ],
    };

    componentDidMount = () => {

        // getting all the times from medList
        const medList = this.props.medList;

        let main = [];

        medList.forEach((med)=>{
            let temp=[];
            let searchTerm1='';
            let searchTerm2='';
           
           for (let i = 1; i <= 4; i++) {
                searchTerm1 = `time_${i}`;
                searchTerm2 = `direction_${i}`;
                temp.push(med[searchTerm1],med[searchTerm2])
            }
            temp=_.compact(temp);
            main.push(_.chunk(temp,2));
        })

        const new_list = Array.from(new Set(_.flatten(main).map(JSON.stringify)), JSON.parse);

        const all_list = this.state.times.concat(new_list);

        // creating unique times from both the time, i.e state times & medList times
        let compactTimes = [];

        let k;
        for (k = 0; k < all_list.length; ++k ) {
            if (this.searchForArray(compactTimes, all_list[k]) === -1) {
                compactTimes.push(all_list[k])
            }
        }

        this.setState({
            times: compactTimes,
        });
        
    }

    searchForArray = (haystack, needle) => {
        let i, j, current;
        for (i = 0; i < haystack.length; ++i) {
            if (needle.length === haystack[i].length) {
                current = haystack[i];
                for (j = 0; j < needle.length && needle[j] === current[j]; ++j);
                if(j === needle.length)
                    return i;
            }
        }
        return -1;
    }

    render() {

        const { handleAddTime, onReset } = this.props;

        const timeButtons = this.state.times.map(time => (
            <Col span={3}>
                <Button onClick={() => handleAddTime(time)}>
                    {time[0]}
                </Button>
                <hr/>
            </Col>
        ));

        return (
            <Card>

                <div>
                    <Row type="flex" justify="space-around" >
                        { timeButtons }
                    </Row>
                </div>

                <br/><br/>


                <Button type="danger" onClick={onReset}>Reset All Time</Button>
                
            </Card>
        );
    }
}

const mapStateToProps = state => {
    return {
        medList: state.AppState.medicineList,
    }
};

export default connect(mapStateToProps, null)(DoseTimeDirectionPool);




// WEBPACK FOOTER //
// ./src/component/AddingMedToOrder/DoseTimeDirectionPool/DoseTimeDirectionPool.js